export default __webpack_public_path__ + "static/media/hht1_ep15_timeline_12.1a4e6c86.png";